var render = function render(){
  var _vm$cloud$label;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "cloud-holder-wrapper",
    "class": {
      'pad-bot-15': _vm.opened
    }
  }, [_c('div', {
    staticClass: "header-wrapper"
  }, [_c('div', {
    staticClass: "add-file-wrapper"
  }, [_c('button', {
    staticClass: "sub-ctass image-upload-btn add-file-button pointer blc-color pop-500",
    on: {
      "click": function click($event) {
        return _vm.openFileUploader();
      }
    }
  }, [_vm._v(" + pridať ")]), _vm.files.length ? _c('button', {
    staticClass: "cloud-zip-button pointer",
    attrs: {
      "type": "button",
      "disabled": _vm.zipLoading
    },
    on: {
      "click": _vm.downloadCloudArchive
    }
  }, [_vm._v(" " + _vm._s(_vm.zipLoading ? "Balím…" : "Stiahnuť ZIP") + " ")]) : _vm._e()]), _c('div', {
    staticClass: "cloudLabel"
  }, [_c('div', {
    attrs: {
      "id": "Client-name"
    }
  }, [_vm._v(_vm._s(_vm.cloud.type_label)), _c('br'), _c('span', {
    staticClass: "_900 big"
  }, [_vm._v(_vm._s(!((_vm$cloud$label = _vm.cloud.label) !== null && _vm$cloud$label !== void 0 && _vm$cloud$label.includes("nomail.bankari.sk")) ? _vm.cloud.label : ""))])]), _c('img', {
    staticClass: "activate-button nav-link-icon filter-primary",
    "class": {
      'rotate': _vm.opened
    },
    attrs: {
      "src": "https://uploads-ssl.webflow.com/648b04f9d8e52d9524912b4a/648b04f9d8e52d9524912f28_icons8-collapse-arrow.svg",
      "alt": ""
    },
    on: {
      "click": function click($event) {
        _vm.opened = !_vm.opened;
      }
    }
  })])]), _c('v-expand-transition', {
    staticClass: "summary-items-transition"
  }, [_vm.opened && _vm.files.length === 0 ? _c('div', {
    staticClass: "filesList"
  }, [_vm._v(" Tento cloud je zatiaľ prázdny, ")]) : _vm.opened && _vm.files.length !== 0 ? _c('div', {
    staticClass: "filesList"
  }, [_vm._l(_vm.files, function (cloudFile, index) {
    var _cloudFile$type, _cloudFile$type2;
    return ((_cloudFile$type = cloudFile.type) === null || _cloudFile$type === void 0 ? void 0 : _cloudFile$type.code) !== 'vygenerovana_ziadost' ? _c('div', {
      key: index,
      staticClass: "discount-item field-names",
      attrs: {
        "data-v-09f30b34": ""
      }
    }, [cloudFile.loading ? _c('v-progress-circular', {
      staticClass: "loading-spinner small",
      attrs: {
        "indeterminate": ""
      }
    }) : _vm.type && (cloudFile === null || cloudFile === void 0 ? void 0 : (_cloudFile$type2 = cloudFile.type) === null || _cloudFile$type2 === void 0 ? void 0 : _cloudFile$type2.id) !== _vm.type ? _c('div', {
      staticClass: "text-cta pointer",
      on: {
        "click": function click($event) {
          return _vm.assignFileType(cloudFile, index);
        }
      }
    }, [_vm._v(" Vybrať ")]) : _c('div', {
      staticClass: "text-cta pointer"
    }), _c('div', {
      staticClass: "fileName"
    }, [_vm._v(_vm._s(cloudFile.name))]), _c('div', {
      staticClass: "fileTimestamp"
    }, [_vm._v(_vm._s(_vm.getDay(cloudFile.created)) + "." + _vm._s(_vm.getMonth(cloudFile.created)) + "." + _vm._s(_vm.getYears(cloudFile.created)))]), _c('a', {
      staticClass: "text-cta pointer",
      staticStyle: {
        "text-decoration": "none"
      },
      attrs: {
        "href": cloudFile.file,
        "target": "_blank"
      }
    }, [_vm._v(" Stiahnuť ")]), _c('div', {
      staticClass: "text-cta pointer",
      on: {
        "click": function click($event) {
          return _vm.deleteCloudFile(cloudFile, index);
        }
      }
    }, [_vm._v(" Vymazať ")])], 1) : _vm._e();
  }), _vm._l(_vm.loadingFiles, function (_, key) {
    return _c('div', {
      key: key + 999,
      staticClass: "discount-item field-names",
      attrs: {
        "data-v-09f30b34": ""
      }
    }, [_c('v-progress-circular', {
      staticClass: "loading-spinner small",
      attrs: {
        "indeterminate": ""
      }
    })], 1);
  })], 2) : _vm._e()])], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }